<div [ngClass]="item.is_selected ? 'request-item request-item-selected d-flex flex-column' : 'request-item request-item-normal d-flex flex-column'">
  <div class="checkbox-container">
    <div class="checkbox">
      <app-round-checkbox [extraClass]="'small bg-white'" [id]="item.uuid" [isSelected]="item.is_selected" (click)="selectByClick()"></app-round-checkbox>
    </div>
  </div>

  <div class="d-flex flex-row mb-2 justify-content-between">
    <span class="text-bolder">{{item.email}}</span>
  </div>

  <div class="d-flex flex-column mb-2" *ngIf="item.state === 'files_added'">
    <div class="d-flex flex-row">
      <span class="text-normal">{{item.number_of_files }} <span *ngIf="item.number_of_files===1">file</span><span *ngIf="item.number_of_files>1">files</span>,  {{item.files_size | fileSize}}</span>
      <div *ngIf="item.last_opened_at" class="d-flex flex-row">
        <img src="./assets/ui/svg/green/icon-check-correct.svg" class="icon">
        <span class="text-normal">Downloaded</span>
      </div>
      <div *ngIf="!item.last_opened_at" class="d-flex flex-row">
        <img src="./assets/ui/svg/grey/exclamation.svg" class="icon">
        <span class="text-normal">Not downloaded</span>
      </div>
    </div>
    <div class="d-flex flex-row">
      <span class="text-normal">Email received: {{item.files_added_at | date: 'dd.MM.yyyy • HH:mm'}}</span>
    </div>
  </div>
  <div class="d-flex flex-row mb-2" *ngIf="item.state === 'created'">
    <span class="text-normal">Request sent: {{item.created_at | date: 'dd.MM.yyyy • HH:mm'}}</span>
  </div>

  <div class="d-flex flex-row justify-content-end" *ngIf="item.state === 'files_added'">
    <button (click)="download()" class="download-btn">Download</button>
  </div>

  <div class="d-flex flex-row justify-content-end" *ngIf="item.state === 'created' && item.request_type === 'link'">
    <button (click)="getLink()" class="download-btn">Copy the link</button>
  </div>

  <div class="d-flex flex-row justify-content-end" *ngIf="item.state === 'created' && item.request_type === 'email'">
    <button (click)="resendEmail()" class="download-btn" [disabled]="resendingEmail">
      <span>Resend email</span>
      <mat-spinner class="ml-2" color="accent" diameter="20" *ngIf="resendingEmail"></mat-spinner>
    </button>
  </div>
</div>
